// Estado y acciones de la bandeja de avisos: página /notifications y desplegable de la campana.
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { listInbox, markRead, type InboxItem } from '../../data/notifications.ts';

export function useInbox(enabled = true) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const inbox = useQuery({ queryKey: ['inbox'], queryFn: () => listInbox(), refetchInterval: 60_000, enabled });
  const unread = inbox.data?.filter((n) => !n.read_at).length ?? 0;

  async function refresh() {
    await queryClient.invalidateQueries({ queryKey: ['inbox'] });
    await queryClient.invalidateQueries({ queryKey: ['unread'] });
  }

  async function open(item: InboxItem) {
    if (!item.read_at) await markRead([item.id]).catch(() => undefined);
    await refresh();
    void navigate(`/orders/${item.order_id}`);
  }

  async function markAll() {
    await markRead(null).catch(() => undefined);
    await refresh();
  }

  return { inbox, unread, open, markAll };
}
